__webpack_require__.p = "https://addapt.fintech.amazon.dev/";